<template>
    <CodiceFeanorView tool-module="metadataEditor" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
